import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import ru from "./locales/ru.json";

export const SUPPORTED_LANGS = [
    { code: "en", label: "English", flag: "🇬🇧", dir: "ltr" },
    { code: "ar", label: "العربية", flag: "🇸🇦", dir: "rtl" },
    { code: "fr", label: "Français", flag: "🇫🇷", dir: "ltr" },
    { code: "ru", label: "Русский", flag: "🇷🇺", dir: "ltr" },
];

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },
            fr: { translation: fr },
            ru: { translation: ru },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "truheal_lang",
        },
    });

export const applyDirection = (lng) => {
    const meta = SUPPORTED_LANGS.find((l) => l.code === lng);
    const dir = meta ? meta.dir : "ltr";
    if (typeof document !== "undefined") {
        document.documentElement.dir = dir;
        document.documentElement.lang = lng || "en";
    }
};

i18n.on("languageChanged", (lng) => applyDirection(lng));
applyDirection(i18n.language || "en");

export default i18n;
